import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type DownloadProjectClipsMutationVariables = Types.Exact<{
  inputs: Types.DownloadProjectClipsInputs;
}>;

export type DownloadProjectClipsMutation = {
  __typename?: 'Mutation';
  downloadProjectClips: {
    __typename?: 'DownloadClipsMutationResponse';
    code: string;
    success: boolean;
    message: string;
    data?: {
      __typename?: 'DownloadData';
      friendlyFileName: string;
      gcsFileName: string;
      signedURL: string;
      fileFormat: Types.DownloadFileFormat;
      downloadMetricsMetadata: {
        __typename?: 'DownloadMetricsMetadata';
        combinedTextLength: number;
        numberOfClips: number;
        numberOfClipsJustConverted: number;
        zipFileAlreadyExisted?: boolean | null;
      };
    } | null;
  };
};

export type DownloadIndividualClipsMutationVariables = Types.Exact<{
  inputs: Types.DownloadClipsInputs;
}>;

export type DownloadIndividualClipsMutation = {
  __typename?: 'Mutation';
  downloadClips: {
    __typename?: 'DownloadClipsMutationResponse';
    code: string;
    success: boolean;
    message: string;
    data?: {
      __typename?: 'DownloadData';
      friendlyFileName: string;
      gcsFileName: string;
      signedURL: string;
      fileFormat: Types.DownloadFileFormat;
      downloadMetricsMetadata: {
        __typename?: 'DownloadMetricsMetadata';
        combinedTextLength: number;
        numberOfClips: number;
        numberOfClipsJustConverted: number;
        zipFileAlreadyExisted?: boolean | null;
      };
    } | null;
  };
};

export type DownloadTakesMutationVariables = Types.Exact<{
  inputs: Types.DownloadTakesInputs;
}>;

export type DownloadTakesMutation = {
  __typename?: 'Mutation';
  downloadTakes: {
    __typename?: 'DownloadTakesMutationResponse';
    code: string;
    success: boolean;
    message: string;
    integrationType?: Types.UserIntegrationType | null;
    data?: {
      __typename?: 'DownloadData';
      friendlyFileName: string;
      gcsFileName: string;
      signedURL: string;
      fileFormat: Types.DownloadFileFormat;
      downloadMetricsMetadata: {
        __typename?: 'DownloadMetricsMetadata';
        combinedTextLength: number;
        numberOfClips: number;
        numberOfClipsJustConverted: number;
        zipFileAlreadyExisted?: boolean | null;
      };
    } | null;
  };
};

export type DownloadProjectTakesMutationVariables = Types.Exact<{
  inputs: Types.DownloadProjectTakesInputs;
}>;

export type DownloadProjectTakesMutation = {
  __typename?: 'Mutation';
  downloadProjectTakes: {
    __typename?: 'DownloadProjectTakesMutationResponse';
    code: string;
    success: boolean;
    message: string;
    data?: {
      __typename?: 'DownloadData';
      friendlyFileName: string;
      gcsFileName: string;
      signedURL: string;
      fileFormat: Types.DownloadFileFormat;
      downloadMetricsMetadata: {
        __typename?: 'DownloadMetricsMetadata';
        combinedTextLength: number;
        numberOfClips: number;
        numberOfClipsJustConverted: number;
        zipFileAlreadyExisted?: boolean | null;
      };
    } | null;
  };
};

export const DownloadProjectClipsDocument = gql`
  mutation downloadProjectClips($inputs: DownloadProjectClipsInputs!) {
    downloadProjectClips(inputs: $inputs) {
      code
      success
      message
      data {
        friendlyFileName
        gcsFileName
        signedURL
        fileFormat
        downloadMetricsMetadata {
          combinedTextLength
          numberOfClips
          numberOfClipsJustConverted
          zipFileAlreadyExisted
        }
      }
    }
  }
`;
export type DownloadProjectClipsMutationFn = Apollo.MutationFunction<
  DownloadProjectClipsMutation,
  DownloadProjectClipsMutationVariables
>;

/**
 * __useDownloadProjectClipsMutation__
 *
 * To run a mutation, you first call `useDownloadProjectClipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadProjectClipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadProjectClipsMutation, { data, loading, error }] = useDownloadProjectClipsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useDownloadProjectClipsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DownloadProjectClipsMutation,
    DownloadProjectClipsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DownloadProjectClipsMutation,
    DownloadProjectClipsMutationVariables
  >(DownloadProjectClipsDocument, options);
}
export type DownloadProjectClipsMutationHookResult = ReturnType<
  typeof useDownloadProjectClipsMutation
>;
export type DownloadProjectClipsMutationResult =
  Apollo.MutationResult<DownloadProjectClipsMutation>;
export type DownloadProjectClipsMutationOptions = Apollo.BaseMutationOptions<
  DownloadProjectClipsMutation,
  DownloadProjectClipsMutationVariables
>;
export const DownloadIndividualClipsDocument = gql`
  mutation downloadIndividualClips($inputs: DownloadClipsInputs!) {
    downloadClips(inputs: $inputs) {
      code
      success
      message
      data {
        friendlyFileName
        gcsFileName
        signedURL
        fileFormat
        downloadMetricsMetadata {
          combinedTextLength
          numberOfClips
          numberOfClipsJustConverted
          zipFileAlreadyExisted
        }
      }
    }
  }
`;
export type DownloadIndividualClipsMutationFn = Apollo.MutationFunction<
  DownloadIndividualClipsMutation,
  DownloadIndividualClipsMutationVariables
>;

/**
 * __useDownloadIndividualClipsMutation__
 *
 * To run a mutation, you first call `useDownloadIndividualClipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadIndividualClipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadIndividualClipsMutation, { data, loading, error }] = useDownloadIndividualClipsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useDownloadIndividualClipsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DownloadIndividualClipsMutation,
    DownloadIndividualClipsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DownloadIndividualClipsMutation,
    DownloadIndividualClipsMutationVariables
  >(DownloadIndividualClipsDocument, options);
}
export type DownloadIndividualClipsMutationHookResult = ReturnType<
  typeof useDownloadIndividualClipsMutation
>;
export type DownloadIndividualClipsMutationResult =
  Apollo.MutationResult<DownloadIndividualClipsMutation>;
export type DownloadIndividualClipsMutationOptions = Apollo.BaseMutationOptions<
  DownloadIndividualClipsMutation,
  DownloadIndividualClipsMutationVariables
>;
export const DownloadTakesDocument = gql`
  mutation downloadTakes($inputs: DownloadTakesInputs!) {
    downloadTakes(inputs: $inputs) {
      code
      success
      message
      integrationType
      data {
        friendlyFileName
        gcsFileName
        signedURL
        fileFormat
        downloadMetricsMetadata {
          combinedTextLength
          numberOfClips
          numberOfClipsJustConverted
          zipFileAlreadyExisted
        }
      }
    }
  }
`;
export type DownloadTakesMutationFn = Apollo.MutationFunction<
  DownloadTakesMutation,
  DownloadTakesMutationVariables
>;

/**
 * __useDownloadTakesMutation__
 *
 * To run a mutation, you first call `useDownloadTakesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadTakesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadTakesMutation, { data, loading, error }] = useDownloadTakesMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useDownloadTakesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DownloadTakesMutation,
    DownloadTakesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DownloadTakesMutation, DownloadTakesMutationVariables>(
    DownloadTakesDocument,
    options
  );
}
export type DownloadTakesMutationHookResult = ReturnType<typeof useDownloadTakesMutation>;
export type DownloadTakesMutationResult = Apollo.MutationResult<DownloadTakesMutation>;
export type DownloadTakesMutationOptions = Apollo.BaseMutationOptions<
  DownloadTakesMutation,
  DownloadTakesMutationVariables
>;
export const DownloadProjectTakesDocument = gql`
  mutation downloadProjectTakes($inputs: DownloadProjectTakesInputs!) {
    downloadProjectTakes(inputs: $inputs) {
      code
      success
      message
      data {
        friendlyFileName
        gcsFileName
        signedURL
        fileFormat
        downloadMetricsMetadata {
          combinedTextLength
          numberOfClips
          numberOfClipsJustConverted
          zipFileAlreadyExisted
        }
      }
    }
  }
`;
export type DownloadProjectTakesMutationFn = Apollo.MutationFunction<
  DownloadProjectTakesMutation,
  DownloadProjectTakesMutationVariables
>;

/**
 * __useDownloadProjectTakesMutation__
 *
 * To run a mutation, you first call `useDownloadProjectTakesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadProjectTakesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadProjectTakesMutation, { data, loading, error }] = useDownloadProjectTakesMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useDownloadProjectTakesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DownloadProjectTakesMutation,
    DownloadProjectTakesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DownloadProjectTakesMutation,
    DownloadProjectTakesMutationVariables
  >(DownloadProjectTakesDocument, options);
}
export type DownloadProjectTakesMutationHookResult = ReturnType<
  typeof useDownloadProjectTakesMutation
>;
export type DownloadProjectTakesMutationResult =
  Apollo.MutationResult<DownloadProjectTakesMutation>;
export type DownloadProjectTakesMutationOptions = Apollo.BaseMutationOptions<
  DownloadProjectTakesMutation,
  DownloadProjectTakesMutationVariables
>;
